import { render, staticRenderFns } from "./DbSyncManager.vue?vue&type=template&id=16ec9ea0&"
import script from "./DbSyncManager.vue?vue&type=script&lang=ts&"
export * from "./DbSyncManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports